module.exports = __webpack_public_path__ + "img/rate_icon.f68ed628.png";